import React, { Component, Fragment } from 'react'
import { withCookies } from 'react-cookie'
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Toolbar from '@material-ui/core/Toolbar';
import SyncIcon from '@material-ui/icons/Sync';
import ClearIcon from '@material-ui/icons/Clear';
import AddIcon from '@material-ui/icons/Add';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CustomCircularProgress from '../../../custom/CustomCircularProgress';
import RoleApi from '../../../../libs/EdgeVMSCloudApi/Roles'
import GroupApi from '../../../../libs/EdgeVMSCloudApi/Groups'
import { SERVICES, OPERATIONS } from '../../../../constants/permissions'
import CustomTable from '../../../custom/CustomTable';
import CustomTableHead from '../../../custom/CustomTableHead';
import SearchBox from '../../../custom/SearchBox'
import { GetNavParamsFromLocation } from '../../../../libs/Utils'
import { NavTableFooter } from '../../../table'
import ROWS_PER_PAGE_OPTIONS from '../../../../constants/navParams'
import { COOKIES } from '../../../../constants/cookieDefs'
import { ConfirmAction, SelectGroupDialog } from '../../../dialogs'
import { PARENT_TYPES } from '../../../dialogs/SelectGroupDialog'

const useStyles = theme => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    display: 'flex',
  },
  container: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(4),
  },
  title: {
    flexGrow: 1,
    color: theme.palette.secondary.main,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 240,
  },
  actionsCell: {
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
});

class RoleGroupsTab extends Component {
  constructor (props) {
    super(props)

    const { cookies } = props;
    const DefaultNavParams = {
      currentPage: '0',
      rowsPerPage: cookies.get(COOKIES.ROWS_PER_PAGE.name),
      searchString: "",
    }

    this.state = {
      isLoading: true,
      showActionProgress: false,
      confirmDeleteActionOpen: false,
      selectGroupDialogOpen: false,
      role: {},
      roleGroups : {},
      hasDataError: false,
    }

    this.idInAction = null
    this.navParams = GetNavParamsFromLocation(DefaultNavParams)
    this.abortController = new AbortController();
    this.signal = this.abortController.signal;
  }

  async componentDidMount () {
    await this.handleRefresh()
  }

  componentWillUnmount () {
    this.abortController.abort();
  }

  async handleRefresh () {
    if (!this.props.newRole && this.props.match.params.role) {
      this.setState({isLoading: true})

      let response = await RoleApi.FetchRole(this.signal, this.props.match.params.role)
      if (response.error && response.error.name === "AbortError") {
        return;
      }

      this.setState ({ role : response.ok ? response.body : {} })

      if (response.ok) {
        response = await RoleApi.FetchRoleGroups(this.signal, this.props.match.params.role, this.navParams)
        if (response.error && response.error.name === "AbortError") {
          return;
        }

        this.setState({roleGroups: response.ok ? response.body : {}})
      } else {
        this.setState({roleGroups: {}})
      }

      this.setState({hasDataError: response.error ? true : false}, () => this.setState({isLoading: false}))
    } else {
      this.setState({isLoading: false})
    }
  };

  handleRequestSearch (event, value) {
    let currentParams = new URLSearchParams(window.location.search)
    currentParams.set('currentPage', '0')

    if (value.length) {
      currentParams.set('searchString', value)
    } else {
      currentParams.delete('searchString')
    }

    window.location.search = currentParams.toString()
  };

  onDeleteActionClick (idInAction) {
    if (idInAction)
    {
      this.idInAction = idInAction
      this.setState({showActionProgress: false})
      this.setState({confirmDeleteActionOpen: true})
    }
  }

  async DeleteActionCallback (userAnswer, toDelete) {
    if (userAnswer && userAnswer === 'ok' && toDelete && toDelete.id) {
      this.setState({showActionProgress: true})

      let response = await GroupApi.DeassignRole(this.signal, toDelete.id, this.props.match.params.role)
      if (response.error && response.error.name === "AbortError") {
        return;
      }

      await this.handleRefresh()
    }
    this.setState({confirmDeleteActionOpen: false})
  };


  render () {
    const { classes, session, newRole } = this.props
    const { isLoading, role, roleGroups, hasDataError } = this.state
    const { currentPage, rowsPerPage, searchString } = this.navParams
    const originLocation = this.props.location.state ? this.props.location.state.originLocation : undefined
    const hasUpdatePermission = session.permissions[SERVICES.USER][OPERATIONS.UPDATE]

    if (newRole) {
      return null
    }

    let { total, offset, groups } = roleGroups
    if (groups == null) {
      groups = []
    }

    if (total == null) {
      total = 0
    }

    if (offset == null) {
      offset = 0
    }

    return (
      <div className={classes.root}>
        <Container maxWidth="md" className={classes.container}>
          <Toolbar>
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small"/>} color="inherit" aria-label="breadcrumb" className={classes.title}>
              <Link component="button" variant="h6" href="/" color="inherit" title='Back To Roles'
                onClick={() => originLocation ? window.location.href = originLocation : this.props.history.push('/mainmenu/admin/roles')}
              >
                Roles
              </Link>
              { role.name &&
                <Link component="button" variant="h6" href="/" color="inherit" title='Back to Details'
                  onClick={() => this.props.history.push(this.props.location.pathname.substring(0, this.props.location.pathname.lastIndexOf('/')), this.props.location.state)}
                >
                  { role.name }
                </Link>
              }
              { role.name &&
                <Typography component="h1" variant="h6" color="inherit" noWrap>
                  Groups
                </Typography>
              }
            </Breadcrumbs>

            <Tooltip title="Back">
              <span>
                <IconButton id="go-back-icon" disabled={isLoading} onClick={this.props.history.goBack.bind(this)}>
                  <ArrowBackIcon />
                </IconButton>
              </span>
            </Tooltip>
            { hasUpdatePermission &&
              <Tooltip title={"Add Role To Group"}>
                <span>
                  <IconButton id="add-to-group-icon" disabled={isLoading || hasDataError} onClick={() => this.setState({selectGroupDialogOpen: true})}>
                    <AddIcon />
                  </IconButton>
                </span>
              </Tooltip>
            }
            <Tooltip title="Refresh">
              <span>
                <IconButton id="refresh-icon" disabled={isLoading} onClick={this.handleRefresh.bind(this)}>
                  <SyncIcon />
                </IconButton>
              </span>
            </Tooltip>
          </Toolbar>
          <Box display="flex" justifyContent="flex-end">
            <SearchBox
              className={classes.formControl}
              disabled={isLoading}
              onSearch={this.handleRequestSearch.bind(this)}
              searchString={searchString}
            />
          </Box>
          { isLoading ? (
            <CustomCircularProgress />
          ) : (
            <Fragment>
              <CustomTable>
                <CustomTableHead>
                  <TableRow selected={true}>
                    <TableCell>Name</TableCell>
                    <TableCell>Description</TableCell>
                    { hasUpdatePermission &&
                      <TableCell align="center">Actions</TableCell>
                    }
                  </TableRow>
                </CustomTableHead>
                {groups.length ? (
                  <TableBody>
                    {groups.map((group) => {
                      return (
                        <TableRow hover key={group.id}>
                          <TableCell title="Click To View Group Details" onClick={() => this.props.history.push("/mainmenu/admin/groups/details/" + group.id)}>
                            {group.name}
                          </TableCell>
                          <TableCell title="Click To View Group Details" onClick={() => this.props.history.push("/mainmenu/admin/groups/details/" + group.id)}>
                            {group.description}
                          </TableCell>
                          { hasUpdatePermission &&
                            <TableCell className={classes.actionsCell}>
                              <Tooltip title="Remove From Role">
                                <IconButton
                                  size={'small'}
                                  onClick={this.onDeleteActionClick.bind(this, group)}
                                >
                                  <ClearIcon fontSize={'small'} />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          }
                        </TableRow>
                    )})}
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableRow>
                      <TableCell align='center' colSpan={hasUpdatePermission ? 3 : 2}>No Group Assignation</TableCell>
                    </TableRow>
                  </TableBody>
                )}
                <NavTableFooter
                  labelRowsPerPage='Groups per page'
                  rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                  count={total}
                  rowsPerPage={parseInt(rowsPerPage, 10)}
                  currentPage={total > 0 ? parseInt(currentPage, 10) : 0}
                />
              </CustomTable>
            </Fragment>
          )}
        </Container>

        <SelectGroupDialog
          open={this.state.selectGroupDialogOpen === true}
          session={session}
          parent={role}
          parentType={PARENT_TYPES.ROLE}
          doneCallback={() => this.setState({selectGroupDialogOpen: false}, () => this.handleRefresh())}
          assignGroup={async (signal, groupId) => await GroupApi.AssignRole(signal, groupId, role.id)}
          deassignGroup={async (signal, groupId) => await GroupApi.DeassignRole(signal, groupId, role.id)}
        />

        <ConfirmAction
          title="Remove Group Assignment ?"
          open={this.state.confirmDeleteActionOpen === true}
          showProgress={this.state.showActionProgress}
          progressMsg="Processing request to remove group assignment..."
          actionCallback={this.DeleteActionCallback.bind(this)}
          callbackContext={this.idInAction}
        >
          {`Are you sure you want to remove ${role.name ? "\"" + role.name + "\"" : "this"} role assignment from ${this.idInAction ? "\"" + this.idInAction.name + "\"" : "this"} group ?`}
        </ConfirmAction>

      </div>
    )
  }
}

export default withCookies(withStyles(useStyles)(RoleGroupsTab))
